import constants from './constants';
import { createFailure, createRequest, createSuccess } from 'ducks/helpers';

export const sitesRequest = createRequest(constants.sites);
export const sitesSuccess = createSuccess(constants.sites);
export const sitesFailure = createFailure(constants.sites);

export const addSiteRequest = createRequest(constants.addSite);
export const addSiteSuccess = createSuccess(constants.addSite);
export const addSiteFailure = createFailure(constants.addSite);

export const updateSiteRequest = createRequest(`${constants.sites}_UPDATE`);
export const updateSiteSuccess = createSuccess(`${constants.sites}_UPDATE`);
export const updateSiteFailure = createFailure(`${constants.sites}_UPDATE`);

export const updateSiteEmailsRequest = createRequest(`${constants.sites}_UPDATE_EMAIL`);
export const updateSiteEmailsSuccess = createSuccess(`${constants.sites}_UPDATE_EMAIL`);
export const updateSiteEmailsFailure = createFailure(`${constants.sites}_UPDATE_EMAIL`);

export const getSiteEmailsRequest = createRequest(`${constants.sites}_GET_EMAIL`);
export const getSiteEmailsSuccess = createSuccess(`${constants.sites}_GET_EMAIL`);
export const getSiteEmailsFailure = createFailure(`${constants.sites}_GET_EMAIL`);

export const updateSiteFormsRequest = createRequest(`${constants.sites}_UPDATE_FORMS`);
export const updateSiteFormsSuccess = createSuccess(`${constants.sites}_UPDATE_FORMS`);
export const updateSiteFormsFailure = createFailure(`${constants.sites}_UPDATE_FORMS`);

export const siteFormsRequest = createRequest(`${constants.sites}_REQUEST_FORMS`);
export const siteFormsSuccess = createSuccess(`${constants.sites}_REQUEST_FORMS`);
export const siteFormsFailure = createFailure(`${constants.sites}_REQUEST_FORMS`);


export const requestSites = sitesRequest;
export const requestAddSite = addSiteRequest;
export const updateSite = updateSiteRequest;
export const updateSiteEmails = updateSiteEmailsRequest;
export const getSiteEmails = getSiteEmailsRequest;
export const updateSiteForms = updateSiteFormsRequest;
export const requestSiteForms = siteFormsRequest;
